import { render, staticRenderFns } from "./PagoExterno.vue?vue&type=template&id=2c01a741&"
import script from "./PagoExterno.vue?vue&type=script&lang=js&"
export * from "./PagoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports